import React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import Bannerfooter from '../../../../../components/Bannerfooter/Bannerfooter'
import ReactPlayer from 'react-player'
import { Button, CardActionArea, CardActions } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import useGlobalConfig from '../../../../../hooks/globalConfig';
import { NavLink } from 'react-router-dom';
const Pos5 = () => {

const footermensaje = {
  className: 'resaltadoCurvo FloatRignt marging20',
  title:  'CIUDADES INTELIGENTES',
  paragramh:'La electromovilidad contribuye también al desarrollo de ciudades inteligentes o smart cities (en inglés), concepto que apunta al desarrollo urbano sostenible, dando respuesta a las necesidades de la sociedad pero también de organizaciones y empresas, buscando la eficiencia energética y la reducción de emisiones de CO2, al mismo tiempo que el desarrollo económico y el cuidado del medioambiente. La electromovilidad, a través de la innovación, infraestructura y tecnología pueden responder a necesidades de una ciudad inteligente desde el ámbito de la movilidad, que es cero emisión, pero también para disminuir los costos de uso de energía eléctrica pues las tecnologías de carga bidireccionales inteligentes permiten a los vehículos eléctricos acumular energía en periodos de baja demanda y con alta producción de electricidad por medio de recursos renovables y luego entregársela, según su disponibilidad, a la red en periodos de alta demanda. También, los vehículos eléctricos aportan al desarrollo de ciudades inteligentes pues se consideran sensores móviles que capturan datos urbanos mientras están en movimiento.' 
    }

    const {img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, ecotribicci, homeImgUrl,biccidashboard,ecotribicci2,cobertura,
      btnvehicle,
      btnuseradmin,
      btnacuerdo,    icomshome1, icomshome2, icomshome3, icomshome4, icomshome5,} = useGlobalConfig()

  return (
    <div>
    <Grid celled='internally'>

    <Grid.Row  className="rowmarging">
    <Grid.Column computer={8} mobile={16} tablet={6} id="paragraph2">
    <div className="text-center">
      <span className="abs-center"><h1  className="resaltadoCurvo">BICCI EXPRESS</h1></span><br></br>
      <span className="abs-center"><h2 className="resaltadoCurvo">Somos BICCI nuestro servicio de logística y transporte comprometida con el desarrollo social, que busca ayudar al medio ambiente por medio de la tecnología y la electromovilidad de nuestros vehículos, reduciendo la huella de carbono en la ciudad.</h2></span>
       </div>
      </Grid.Column>
      <Grid.Column computer={8} mobile={16} tablet={6}>
        <Image src={homeImgUrl} />
      </Grid.Column>
    </Grid.Row>

    <Grid.Row className='bannertiposdeenvio'>
      <Grid.Column computer={16} mobile={16} tablet={16} >
        <div className='colorWhite font-sizeBig'>Llega a  más con<br></br>
        <strong>nuestras modalidades de envíos</strong></div>
        <div className='cardHomeContent' >
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250,}}>
            <CardActionArea>
            
                <img src={img1} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>

                <Typography gutterBottom variant="h5" component="div">
                Quick commerce ecosustentable
                </Typography>
                <Typography variant="body2" color="text.secondary">
                Entregamos tus paquetes desde tu negocio hasta las manos de tus clientes e impulsados mediante unos motores eléctricos.  
                </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                Registrar mi empresa
                </Button>
            </CardActions>
        </Card>

        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, }}>
            <CardActionArea>
            
                <img src={img2} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>

                <Typography gutterBottom variant="h5" component="div">
                Same Day
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Genera tus órdenes de despacho antes de las 12h y tus clientes los reciben antes de las 21h.
                </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                Registrar mi empresa
                </Button>
            </CardActions>
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250,}}>
            <CardActionArea>
            
                <img src={img3} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>

                <Typography gutterBottom variant="h5" component="div">
                Next Day
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Envíos para el día siguiente que no dejan huella C02 Free
                </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                Registrar mi empresa
                </Button>
            </CardActions>
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250,}}>
            <CardActionArea>
            
                <img src={img4} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>

                <Typography gutterBottom variant="h5" component="div">
                Retorno y devoluciones
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Devuelve tu envío, sin problemas, fácil y rápido.  
                </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                Registrar mi empresa
                </Button>
            </CardActions>
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, }}>
            <CardActionArea>
            
                <img src={img5} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>

                <Typography gutterBottom variant="h5" component="div">
                Bicci express
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Envío express de punto A a punto B.
                </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                Registrar mi empresa
                </Button>
            </CardActions>
        </Card>

      </div>
       <br></br>
      </Grid.Column>
    </Grid.Row>



    <Grid.Row  className="rowmarging">
      <Grid.Column computer={16} mobile={16} tablet={16}>
      <div className="text-center"><br></br>
      <span className="abs-center"><h2 className="resaltadoCurvo subtilepage">BENEFICIOS DE LA ELECTROMOVILIDAD.</h2></span>
       </div>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row  className="rowmarging">
    <Grid.Column computer={8} mobile={16} tablet={6}>
      <Image src={ecotribicci} />
      </Grid.Column>
    <Grid.Column computer={8} mobile={16} tablet={6} id="paragraph2" className="columnleft">
    <div><h2 className="resaltadoCurvo subtilepage">MEJORAS LA CALIDAD DEL AIRE:</h2>
        <p>Un vehículo eléctrico es CERO EMISIÓN, es decir, mientras está en movimiento no produce emisiones de gases ni partículas, lo que impacta directamente en mejorar la calidad de aire en las ciudades pues se disminuye la contaminación local. En Chile, 12 ciudades han sido declaradas como zonas saturadas en material particulado, siendo el sector transporte una de las principales preocupaciones para las autoridades. Mejorando la calidad del aire, se generan beneficios directos en salud y enfermedades respiratorias, principalmente en la población infanto-juvenil y en adultos mayores.</p>
        </div>
        <div>
        <h2 className="resaltadoCurvo subtilepage"> JUNTOS CONTRA EL CAMBIO CLIMÁTICO:</h2>
        <p>La electromovilidad utiliza como fuente energética la electricidad, es decir, no ocurre combustión fósil (gasolina, diésel, gas) y por tanto no se producen emisiones directas de CO2 mientras un vehículo eléctrico se mueve, contribuyendo así a combatir el cambio climático. Este beneficio se logra maximizar cuando la electricidad es generada también con tecnologías de cero emisión, como lo son las energías renovables.</p>
        </div>
      </Grid.Column>

    </Grid.Row>




    <Grid.Row className='metricasenvio'>
      <Grid.Column computer={16} mobile={16} tablet={16} >
  
        <div className='cardHomeContent' >
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, border:'none'}}>
            <CardActionArea>
            
                <img src={icomshome5} alt="bicci" className='Home_cardContent'/>
              
                <CardContent>

                <Typography gutterBottom variant="h1" component="div" className="fonZiseBig">
                14.500
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght" >
                Paquetes entregados. 
                </Typography>
                </CardContent>
            </CardActionArea>
         
        </Card>

        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, border:'none'}}>
            <CardActionArea>
            
                <img src={icomshome3} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>
           
                <Typography gutterBottom variant="h1" component="div" className="fonZiseBig">
                11,727
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Clientes felices
                </Typography>
                </CardContent>
            </CardActionArea>
        
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, border:'none'}}>
            <CardActionArea>
            
                <img src={icomshome2} alt="bicci" className='Home_cardContent'/>

                <CardContent>

                <Typography gutterBottom variant="h1" component="div" className="fonZiseBig">
               33
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Tiendas afiliadas cada semana
                </Typography>
                </CardContent>
            </CardActionArea>
         
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, border:'none'}}>
            <CardActionArea>
            
                <img src={icomshome4} alt="bicci" className='Home_cardContent'/>
               
                <CardContent>

                <Typography gutterBottom variant="h1" component="div" className="fonZiseBig">
               468
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                Tiendas usan nuestro shipping.  
                </Typography>
                </CardContent>
            </CardActionArea>
          
        </Card>
        <Card className='cardHome' sx={{ maxWidth: 250, margin:2, minWidth: 250, border:'none' }}>
            <CardActionArea>
            
                <img src={icomshome1} alt="bicci" className='Home_cardContent'/>
            
                <CardContent>
               
                <Typography gutterBottom variant="h1" component="div" className="fonZiseBig">
                58TH
                </Typography>
                <Typography variant="body2" color="text.secondary" className="min-heght">
                CO2 Ahorrados.
                </Typography>
                </CardContent>
            </CardActionArea>
           
        </Card>

      </div>
       <br></br>
      </Grid.Column>
    </Grid.Row>





    <Grid.Row className="rowmargingsmall" >
      <Grid.Column computer={8} mobile={16} tablet={6}  id="Buscadorletf">
      <NavLink  to="/eco-bicci" exact>
      <Image  id="bannerServicios" src={img1} />
      </NavLink>

      </Grid.Column>
      <Grid.Column computer={8} mobile={16} tablet={10} id="Buscadorright" >
      <NavLink  to="/eco-bicci" exact>  
      <div>
      <span><h1 id="firstmensaje">"Comprometidos con el desarrollo social y con la reducción de la huella de carbono en la ciudad." </h1></span>
       </div>
       </NavLink>
       <NavLink  className="btn btn-primary" to="/eco-bicci" exact>Conoce mas...</NavLink>
      </Grid.Column>
    </Grid.Row>


    <Grid.Row className='bannertiposdeservicio fondobicci'>
      <Grid.Column computer={16} mobile={16} tablet={16} >
        <div className='colorWhite font-sizeBig'><h2 className='colorWhite'>Nuestros 
        <strong> servicios</strong> </h2></div>
        <div className='cardHomeContent' >
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
            <div className="services_badgeContainer">
                <span className="services_badge">Nuevo</span>
                </div>


                <div className="services_header"> 
                 <span className="services_border"></span>ENVÍOS EXPRESS
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
                
                <img src={img11} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

              
                <Typography variant="h5" color="text.secondary" className="min-heght">
                Entregamos impulsados mediante unos motores eléctricos.  
                </Typography>
                </CardContent>
            </CardActionArea>
     
        </Card>

        <Card className='cardHome3' sx={{ maxWidth: 300, margin:2, minWidth: 280, }}>
            <CardActionArea>
            <div className="services_badgeContainer">
                <span className="services_badge">Próximamente</span>
                </div>

            <div className="services_header"> 
                 <span className="services_border"></span>PUNTOS DE DESPACHO
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
              
                <img src={img12} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

             
                <Typography variant="h5" color="text.secondary" className="min-heght">
                Genera tus órdenes de con diferentes puntos despacho.
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
            <div className="services_badgeContainer">
                <span className="services_badge">Nuevo</span>
                </div>
            <div className="services_header"> 
                 <span className="services_border"></span>INTEGRACIONES
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
           
                <img src={img13} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

                <Typography variant="h5" color="text.secondary" className="min-heght">
                Es posible integrarnos a tu plataforma y generar ordenes automaticas en cada compra. previa evaluación. 
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
            <div className="services_badgeContainer">
                <span className="services_badge">Próximamente</span>
                </div>
            <div className="services_header"> 
                 <span className="services_border"></span>GESTION DE RUTAS
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
             
                <img src={img14} alt="bicci" className='Home_cardContent3'/>
                <CardContent>
                <Typography variant="h5" color="text.secondary" className="min-heght">
                Ordena las fechas y prioridades de entregas. 
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280, }}>
            <CardActionArea>
            <div className="services_badgeContainer">
                {/* <span className="services_badge">Nuevo</span> */}
                </div>
            <div className="services_header"> 
                 <span className="services_border"></span>ENVÍOS NEXT DAY
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
                <span className="services_border"> </span>
                <img src={img15} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

               
                <Typography variant="h5" color="text.secondary" className="min-heght">
                Prepara los envíos con antelación, para optimizar tus resultados.
                </Typography>
                </CardContent>
            </CardActionArea>

        </Card>

      </div>
       <br></br>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row className="rowmarging">
      <Grid.Column computer={16} mobile={16} tablet={16}>
      <div className="text-center"><br></br>
      <span className="abs-center"><h2 className="resaltadoCurvo subtilepage">SOLICITAR COBERTURA.</h2></span>
       </div>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row className="rowmarging">
    <Grid.Column computer={8} mobile={16} tablet={6}>
      <Image src={cobertura} />
      
      </Grid.Column>
    <Grid.Column computer={8} mobile={16} tablet={6} id="paragraph2" >
    <div><h2 className="resaltadoCurvo columnright">¿Porque Bicci?</h2>
    <h1 className="resaltado columnright">Conviértete en un punto de recolección de paquetes</h1>
            <h3 className="columnright">
            Genera ingresos extras desde tu local.
            Aumenta la circulación de potenciales clientes en tu negocio, 
            con la posibilidad de aumentar tu ticket promedio de ventas.
            </h3>
            <div className="columnright">
            <NavLink  className="btn btn-primary" to="/contacto" exact>Incluir mi ubicación</NavLink>
            </div>
        
        </div>
      </Grid.Column>



    </Grid.Row>





    <Grid.Row className='bannertiposdeservicio'>
      <Grid.Column computer={16} mobile={16} tablet={16} >
        <div className='colorBlack font-sizeBig'><h2> 
        <strong> NUESTROS OBJETIVOS</strong> </h2></div>
        <div className='cardHomeContent' >
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
                <div className="services_header"> 
                 <span className="services_border"></span>ASESORÍA DE EXPERTOS
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}
                </div>
                <img src={img16} alt="bicci" className='Home_cardContent3'/>
                <CardContent>
                <Typography variant="body1" color="text.secondary" className="min-heght">
                Nos preocupamos por darte la mejor atención. Nuestros asesores dan seguimiento durante todo el recorrido de tu producto hasta llegar a su destino final. Te notificaremos según tus preferencias. 
                </Typography>
                </CardContent>
            </CardActionArea>
     
        </Card>

        <Card className='cardHome3' sx={{ maxWidth: 300, margin:2, minWidth: 280, }}>
            <CardActionArea>
      

            <div className="services_header"> 
                 <span className="services_border"></span>SERVICIOS DE ENCOMIENDAS Y MENSAJERÍAS
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
              
                <img src={img17} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

             
                <Typography variant="body1" color="text.secondary" className="min-heght">
                Puedes cotizar el despacho de tu producto de forma simple, también una vez iniciada la ruta podrás verificar su status en tiempo real
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
         
            <div className="services_header"> 
                 <span className="services_border"></span>¡QUEREMOS SER PARTE DE TU ÚLTIMA MILLA!
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
           
                <img src={img15} alt="bicci" className='Home_cardContent3'/>
            
                <CardContent>

                <Typography variant="body1" color="text.secondary" className="min-heght">
                Tenemos soluciones adaptadas a tus necesidades, Te damos una experiencia de usuario única. Dale un Valor agregado a tus productos al confiar tus despachos en nosotros. 
                Cuidamos el medio ambiente y reducimos la huella de carbono con nuestros vehículos eco-sustentables
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
        <Card className='cardHome3' sx={{ maxWidth: 280, margin:2, minWidth: 280,}}>
            <CardActionArea>
 
            <div className="services_header"> 
                 <span className="services_border"></span>SERVICIOS DE CALIDAD
                 {/* <img src={img11}   className='Home-cardContent-services' alt="Icon text"/> */}

                </div>
             
                <img src={img18} alt="SERVICIO" className='Home_cardContent3'/>
                <CardContent>
                <Typography variant="body1" color="text.secondary" className="min-heght">
                Una variedad de servicios que cubran las necesidades de nuestros clientes, dentro de un ambiente amigable, transparente y ecológico, 
                con una atención personalizada e innovadora, logrando con ello poner el mundo a su alcance.
                </Typography>
                </CardContent>
            </CardActionArea>
    
        </Card>
   

      </div>
       <br></br>
      </Grid.Column>
    </Grid.Row>









    <Grid.Row  className="rowmarging">
    <Grid.Column computer={8} mobile={16} tablet={6}>
      <Image src={ecotribicci2} />
      
      </Grid.Column>
    <Grid.Column computer={8} mobile={16} tablet={6} id="paragraph2">
    <div>
        <h2 className="resaltadoCurvo subtilepage">EVITA LA CONTAMINACIÓN ACÚSTICA:</h2>
        <p>Los vehículos eléctricos casi no emiten ruido, esto se hace más relevante en flotas numerosas de vehículos, en vehículos pesados con motores diesel o en vehículos operando a velocidades por sobre los 50 (km/h). </p>
        </div><br></br>
    <div>
        <h2 className="resaltadoCurvo subtilepage">GESTIÓN DE RESIDUOS RESPONSABLE:</h2>
        <p>Los mecanismos y tecnologías de los vehículos eléctricos no requieren de lubricantes y filtros, lo que reduce el manejo de residuos peligrosos. Por otra parte, los sistemas de freno sufren menor desgaste dado que los vehículos eléctricos emplean un sistema de frenos regenerativos. Las baterías eléctricas, luego de cumplir su ciclo de vida en el vehículo (8 a 10 años) pueden seguir siendo usadas para aplicaciones estacionarias (10 - 15 años) y posteriormente pueden ser recicladas. </p>
        </div><br></br>
    <div>
    <h2 className="resaltadoCurvo subtilepage"> BENEFICIOS DE LA ELECTROMOVILIDAD</h2>
    <p>Cuando logramos transportar una determinada cantidad de kilómetros a personas o carga pero utilizando menos energía, entonces estamos haciendo eficiencia energética en el transporte. Un vehículo eléctrico gasta en torno a un quinto de la energía que un vehículo a combustión equivalente, principalmente porque las eficiencias de un motor de combustión interna no superan el 50% mientras que las de un motor eléctrico están por sobre un 95%. Además, los vehículos eléctricos tienen la ventaja de recuperar energía gracias a los sistemas de frenos regenerativos. Por lo tanto, para una misma distancia y una misma condición de carga o pasajeros transportados, esta eficiencia energética se traduce en un ahorro económico en la operación.</p>
        </div>
      </Grid.Column>

    </Grid.Row>

    
    <br></br>
    <Grid.Row className="rowmargingsmall">
      <Grid.Column computer={16} mobile={16} tablet={16}>
      <div className="text-center"><br></br>
      <span className="abs-center"><h2 className="resaltadoCurvo subtilepage">MÁS SOBRE BICCI.</h2></span>
       </div>
      </Grid.Column>
    </Grid.Row>
    <br></br>
    <Grid.Row className="rowmarging">
     <Grid.Column computer={8} mobile={16} tablet={6} >
      <Grid>
      <Grid.Row >
        <div className="rowblock">
         <div className="rowblockl">
         <Image src={btnvehicle} className='imgbotomsr' />
         </div>
         <div className="rowblockr">
              <h5 className="columnright">
               Próximamente, Durante los plazos de entrega, usted y sus clientes pueden saber exactamente adónde va el paquete con nuestra tecnología de seguimiento en tiempo real.
              </h5>  
         </div>
         </div>

         <br></br>
         <div className="rowblock">
         <div className="rowblockl">
        <Image src={btnuseradmin} className='imgbotomsl'/>
        </div>
         <div className="rowblockr">
        <h5 className="columnleft">
        El reloj comienza a correr cuando crea la orden en nuestro sistema y uno de nuestros riders se ocupara de poner el pedido en las manos de tu cliente.
              </h5>  
        </div>
        
        <br></br>
        </div>
        <div className="rowblock">
         <div className="rowblockl">
        <Image src={btnacuerdo} className='imgbotomsr'/>
        </div>
         <div className="rowblockr">
        <h5 className="columnright">
        Potenciamos nuestros clientes, asegurando soluciones logísticas enfocadas al objetivo correcto, con nuestro excelente servicio y la última tecnología..</h5>  
        </div><br></br>
        </div>
    </Grid.Row>
      </Grid> 
    </Grid.Column>

    <Grid.Column computer={8} mobile={16} tablet={6}  >
    <Image src={biccidashboard}/>
    </Grid.Column>  
      </Grid.Row>
<br></br>

<Grid.Row  className="rowmarging">
    <Grid.Column computer={16} mobile={16} tablet={6}  className="paragraphtop" id="paragraph2">
    <div>
        <h2 className="resaltadoCurvo subtilepage">DIVERSIFICACIÓN ENERGÉTICA:</h2>
        <p>Como se ha dicho previamente, el 98% de la energía que consume el sector transporte corresponde a petróleo y sus derivados, por lo tanto electrificar el parque vehicular de Chile significa diversificar la matriz energética en este sector, hacerla menos dependiente de los combustibles fósiles y de la volatilidad de sus precios dado que somos un país importador. Chile ya inició el camino de la diversificación energética en el sector de generación eléctrica, donde las energías renovables vienen desplazando las centrales termoeléctricas convencionales y donde se espera que al 2050 la participación de la generación con energías renovables supere el 70% de la matriz. </p>
        </div>
      </Grid.Column>
 
   
    </Grid.Row>

  </Grid> 



  <Bannerfooter footermensaje={footermensaje}/>
  </div>
  );
};

export default Pos5;
